import { CuisineCategoryButton } from 'components/cards/CuisineCategoryButton';
import { CarouselRow } from 'components/carousels/carousel-row';
import { useCarousel } from 'components/carousels/CarouselController';
import { ScrollButtons } from 'components/carousels/ScrollButtons';
import { MaxWidthContainer } from 'components/city-blocks/max-width-container';
import { useRefState } from 'hooks/useRefState';
import React from 'react';
import { CuisineFilterButton } from 'utils/cuisine-util';
import { CityPageFilterFragment } from 'utils/gqlReactTypings.generated.d';

const PADDING = 16;
const SHADOW_BREATHING_ROOM = 18;
const IS_ONSCREEN_THRESHOLD = 64;

interface IProps {
  id?: string;
  className?: string;
  title?: string;
  positioningCopy?: string | null;
  cuisineButtons: CuisineFilterButton[];
  activeFilter?: CityPageFilterFragment;
}

export const CuisineCarousel: React.FC<IProps> = ({
  id,
  className,
  title,
  positioningCopy,
  cuisineButtons,
  activeFilter,
}) => {
  const [ref, setRef] = useRefState<HTMLDivElement>();
  const { scrollLeft, scrollRight, numElementsLeft, numElementsRight, hasOverflow } = useCarousel(
    ref,
    cuisineButtons,
    PADDING,
    IS_ONSCREEN_THRESHOLD
  );

  if (!cuisineButtons?.length) return null;

  return (
    <MaxWidthContainer id={id} className={`my-4 ${className}`}>
      {title && (
        <div className='mb-6 flex flex-col px-4 md:px-0'>
          <h3 className='m-0 text-2xl font-bold text-neutral-800 md:text-3xl'>{title}</h3>
          {positioningCopy && <span>{positioningCopy}</span>}
        </div>
      )}
      <div className={`relative flex w-full flex-row `}>
        <CarouselRow padding={PADDING} shadowBreathingRoom={SHADOW_BREATHING_ROOM} ref={setRef}>
          {cuisineButtons.map((button) => (
            // TODO: Gil Note: De-risk href construction; it could already have an anchor in it
            //                 https://app.asana.com/0/1203388046912288/1203603261499135/f
            <CuisineCategoryButton
              key={button.href}
              href={`${button.href}${id ? `#${id}` : ''}`}
              item={button.category}
              active={activeFilter?.cuisineCategoryId === button.category.id}
            />
          ))}
        </CarouselRow>

        {hasOverflow && (
          <ScrollButtons
            className='absolute right-[-60px] top-0 hidden md:flex'
            elementName='dishes-carousel-scroll-buttons'
            scrollRight={scrollRight}
            scrollLeft={scrollLeft}
            numElementsLeft={numElementsLeft}
            numElementsRight={numElementsRight}
          />
        )}
      </div>
    </MaxWidthContainer>
  );
};
